<div class="dynamic-dropdown-container">
  <h3>Autentique Dropdown 'Generator'</h3>

  <div class="dropdown-generator-layout">
    <div class="dropdown-options">
      <div class="dropdown-sections">
        <section class="dropdown-section">
          <h4>Menu principal</h4>

          <div class="dropdown-option">
            <label for="dropdownClosedMenuTitle">Title:</label>
            <input id="dropdownClosedMenuTitle" type="text" [(ngModel)]="closedMenuTitle" (ngModelChange)="updateDropdownCode()" />
          </div>

          <div class="dropdown-option">
            <label for="dropdownClosedMenuIcon">Menu Icon</label>
            <select id="dropdownClosedMenuIcon" [(ngModel)]="closedMenuIcon" (change)="updateDropdownCode()">
              <option value="">Sem icone</option>
              <option value="chevron">chevron</option>
              <option value="ellipsis">ellipsis</option>
            </select>
          </div>
          <div class="dropdown-option">
            <label for="dropdownClosedMenuTextColor">Menu text color</label>
            <select id="dropdownClosedMenuTextColor" [(ngModel)]="closedMenuTextColor" (change)="updateDropdownCode()">
              <optgroup label="primary">
                <option value="primary-50">primary-50</option>
                <option value="primary-100">primary-100</option>
                <option value="primary-200">primary-200</option>
                <option value="primary-300">primary-300</option>
                <option value="primary-400">primary-400</option>
                <option value="primary-500">primary-500</option>
                <option value="primary-600">primary-600</option>
                <option value="primary-700">primary-700</option>
                <option value="primary-800">primary-800</option>
                <option value="primary-900">primary-900</option>
                <option value="primary-950">primary-950</option>
              </optgroup>
              <optgroup label="autentigrey">
                <option value="autentigrey-50">autentigrey-50</option>
                <option value="autentigrey-100">autentigrey-100</option>
                <option value="autentigrey-200">autentigrey-200</option>
                <option value="autentigrey-300">autentigrey-300</option>
                <option value="autentigrey-400">autentigrey-400</option>
                <option value="autentigrey-500">autentigrey-500</option>
                <option value="autentigrey-600">autentigrey-600</option>
                <option value="autentigrey-700">autentigrey-700</option>
                <option value="autentigrey-800">autentigrey-800</option>
                <option value="autentigrey-900">autentigrey-900</option>
                <option value="autentigrey-950">autentigrey-950</option>
              </optgroup>
            </select>
          </div>
          <div class="dropdown-option">
            <label for="dropdownClosedMenuIconFontSize">Menu Icon Font Size</label>
            <select id="dropdownClosedMenuIconFontSize" [(ngModel)]="closedMenuIconFontSize" (change)="updateDropdownCode()" [disabled]="!hasClosedMenuIcon">
              <option value="10">10px</option>
              <option value="12">12px</option>
              <option value="14">14px</option>
              <option value="16">16px</option>
              <option value="18">18px</option>
              <option value="20">20px</option>
              <option value="24">24px</option>
            </select>
          </div>
          <div class="dropdown-option">
            <label for="dropdownClosedMenuStyle">Menu style</label>
            <select id="dropdownClosedMenuStyle" [(ngModel)]="closedMenuStyle" (change)="updateDropdownCode()">
              <option value="">Sem variação</option>
              <option value="filled-blue">filled blue</option>
              <option value="filled-grey">filled grey</option>
              <option value="filled-white">filled white</option>
              <option value="corner">Corner</option>
            </select>
          </div>
          <div class="dropdown-option">
            <label for="dropdownClosedMenuSize">Menu size</label>
            <select id="dropdownClosedMenuSize" [(ngModel)]="closedMenuSize" (change)="updateDropdownCode()">
              <option value="">default</option>
              <option value="compact">compact</option>
            </select>
          </div>
        </section>

        <section class="dropdown-section">
          <h4>Option</h4>

          <div class="dropdown-option">
            <label for="dropdownOptionElement">Element</label>
            <select id="dropdownOptionElement" [(ngModel)]="optionElement" [disabled]="hasSwitch">
              <option value="button">button</option>
              <option value="anchor">anchor</option>
            </select>
          </div>

          <label>
            Icon
            <input type="checkbox" [(ngModel)]="hasIcon" />
          </label>
          <div class="dropdown-option">
            <label for="dropdownIconColor">Icon Color</label>
            <select id="dropdownIconColor" [(ngModel)]="iconColor" [disabled]="!hasIcon || itemColor === 'danger'">
              <option value="50">autentigrey-50</option>
              <option value="100">autentigrey-100</option>
              <option value="200">autentigrey-200</option>
              <option value="300">autentigrey-300</option>
              <option value="400">autentigrey-400</option>
              <option value="500">autentigrey-500</option>
              <option value="600">autentigrey-600</option>
              <option value="700">autentigrey-700</option>
              <option value="800">autentigrey-800</option>
              <option value="900">autentigrey-900</option>
              <option value="950">autentigrey-950</option>
            </select>
          </div>
          <div class="dropdown-option">
            <label for="dropdownItemColor">Text color</label>
            <select id="dropdownItemColor" [(ngModel)]="itemColor">
              <option value="text-l2">text-l2</option>
              <option value="text-l1">text-l1</option>
              <option value="danger">danger</option>
            </select>
          </div>
          <div class="dropdown-option">
            <label for="dropdownItemFontWeight">Font weight</label>
            <select id="dropdownItemFontWeight" [(ngModel)]="itemFontWeight">
              <option value="300">300</option>
              <option value="400">400</option>
              <option value="500">500</option>
              <option value="600">600</option>
              <option value="700">700</option>
            </select>
          </div>
          <label>
            Switch
            <input type="checkbox" [(ngModel)]="hasSwitch" [disabled]="hasArrow" />
          </label>
          <label>
            Arrow
            <input type="checkbox" [(ngModel)]="hasArrow" [disabled]="hasSwitch" />
          </label>
        </section>

        <section class="dropdown-section">
          <h4>Description</h4>

          <label>
            Description
            <input id="dropdownDescriptionEnabled" type="checkbox" [(ngModel)]="hasDescription" />
          </label>
          <div class="dropdown-option">
            <label for="dropdownDescriptionColor">Description text color</label>
            <select id="dropdownDescriptionColor" [(ngModel)]="descriptionColor" [disabled]="!hasDescription">
              <option value="text-l2">text-l2</option>
              <option value="text-l1">text-l1</option>
              <option value="danger">danger</option>
            </select>
          </div>
          <label>
            Description border bottom
            <input type="checkbox" [(ngModel)]="hasDescriptionBorderBottom" [disabled]="!hasDescription" />
          </label>
        </section>
      </div>

      <div class="dropdown-actions">
        <button type="button" class="btn-S btn-filled" (click)="addOption()">Adicionar option</button>
        <button type="button" class="btn-S btn-text" (click)="addDivider()">Adicionar HR</button>
        <button type="button" class="btn-S btn-text" (click)="clearOptions()" [disabled]="!options.length">Limpar</button>
      </div>

      @if (options.length) {
        <div class="dropdown-added-options">
          @for (option of options; track option.id) {
            <div class="dropdown-added-option">
              <span>{{ option.hasDivider ? 'HR' : option.text }}</span>
              <button type="button" class="btn-XS btn-text icon-only" (click)="removeOption(option.id)">
                <i class="far fa-times"></i>
              </button>
            </div>
          }
        </div>
      }
    </div>

    <div class="dropdown-preview" appDropdown placement="bottom-right" [autoClose]="false" [sameSizeSubmenus]="true">
      <button
        type="button"
        class="dropdown__toggle-control"
        [ngClass]="getClosedMenuToggleClasses()"
        [class.dropdown__toggle-control--icon-end]="closedMenuTitle && hasClosedMenuIcon"
        [class.dropdown__toggle-control--icon-only]="!closedMenuTitle && hasClosedMenuIcon"
        appDropdownToggle
      >
        @if (closedMenuTitle) {
          <span>{{ closedMenuTitle }}</span>
        }
        @if (closedMenuIcon === 'chevron') {
          <i class="far fa-chevron-down dropdown__toggle-chevron" [ngClass]="getClosedMenuIconClasses()"></i>
        }
        @if (closedMenuIcon === 'ellipsis') {
          <i class="far fa-ellipsis-v" [ngClass]="getClosedMenuIconClasses()"></i>
        }
      </button>

      <div appDropdownMenu class="dropdown-preview__menu">
        @if (!options.length) {
          <span class="dropdown-preview__empty">Nenhuma option adicionada</span>
        }

        @for (option of options; track option.id) {
          @if (option.hasDivider) {
            <hr class="dropdown-divider" />
          } @else if (option.hasSwitch) {
            <label class="dropdown__item-switch dropdown-preview__switch" [ngClass]="getOptionClasses(option)">
              @if (option.hasIcon) {
                <i [class]="defaultIcon"></i>
              }
              <ng-container [ngTemplateOutlet]="optionLabel" [ngTemplateOutletContext]="{ option: option }"></ng-container>
              <app-switch [(ngModel)]="option.switchValue"></app-switch>
            </label>
          } @else {
            @if (option.elementType === 'anchor') {
              <a href="javascript:void(0)" appDropdownItem [submenuToggle]="option.hasArrow ? submenuId(option) : null" [ngClass]="getOptionClasses(option)">
                @if (option.hasIcon) {
                  <i [class]="defaultIcon"></i>
                }
                <ng-container [ngTemplateOutlet]="optionLabel" [ngTemplateOutletContext]="{ option: option }"></ng-container>
              </a>
            } @else {
              <button type="button" appDropdownItem [submenuToggle]="option.hasArrow ? submenuId(option) : null" [ngClass]="getOptionClasses(option)">
                @if (option.hasIcon) {
                  <i [class]="defaultIcon"></i>
                }
                <ng-container [ngTemplateOutlet]="optionLabel" [ngTemplateOutletContext]="{ option: option }"></ng-container>
              </button>
            }
          }
        }
      </div>

      @for (option of options; track option.id) {
        @if (option.hasArrow) {
          <div [appDropdownSubmenu]="submenuId(option)">
            <button type="button" appDropdownBackButton>Voltar</button>
            <button type="button" appDropdownItem>Opção interna</button>
          </div>
        }
      }
    </div>
  </div>

  <div class="value">
    <textarea class="value-show" readonly [value]="htmlCode" placeholder="Adicione uma option para gerar o código." #codeTextarea></textarea>
    <a class="value-copy text-decoration-none" [ngxClipboard]="codeTextarea" (cbOnSuccess)="copySuccess()"></a>
  </div>
</div>

<ng-template #optionLabel let-option="option">
  @if (option.hasDescription) {
    <div>
      <span class="dropdown__item-title">{{ option.text }}</span>
      <span class="dropdown__item-description" [ngClass]="getDescriptionColorClass(option.descriptionColor)">{{ option.description }}</span>
    </div>
  } @else {
    <span>{{ option.text }}</span>
  }
</ng-template>
